<div class="sb" [class.sb--collapsed]="isCollapsed">
  <!-- Toggle button -->
  <button
    type="button"
    class="sb__toggle"
    [matTooltip]="(isCollapsed ? 'Expand' : 'Collapse') + ' Sidebar'"
    matTooltipPosition="right"
    (click)="toggleSidebar()"
    aria-label="Toggle sidebar"
  >
    <i [class]="isCollapsed ? 'bi bi-chevron-right' : 'bi bi-chevron-left'"></i>
    <span class="sb__toggle-text" *ngIf="!isCollapsed">Menu</span>
  </button>

  <!-- Divider -->
  <div class="sb__divider"></div>

  <!-- Navigation section -->
  <nav class="sb__nav" *ngIf="navigationItems.length > 0">
    <a
      *ngFor="let item of navigationItems"
      [routerLink]="item.route"
      (click)="navigateAndCollapse(item.route)"
      class="sb__nav-item"
      [class.sb__nav-item--active]="isActive(item.route)"
      [matTooltip]="isCollapsed ? (item.translationKey | translate) : ''"
      matTooltipPosition="right"
      [attr.aria-label]="item.translationKey | translate"
    >
      <!-- Icon based on iconType -->
      <span class="sb__nav-icon">
        <mat-icon *ngIf="item.iconType === 'material'">{{ item.icon }}</mat-icon>
        <i *ngIf="item.iconType === 'bootstrap'" class="bi" [class]="'bi-' + item.icon"></i>
        <i *ngIf="item.iconType === 'fontawesome'" class="fa" [class]="'fa-' + item.icon"></i>
      </span>
      
      <!-- Label (hidden when collapsed) -->
      <span class="sb__nav-label" *ngIf="!isCollapsed">
        {{ item.translationKey | translate }}
      </span>
      
      <!-- Active indicator bar -->
      <span class="sb__active-bar" *ngIf="isActive(item.route)"></span>
    </a>
  </nav>

  <!-- Divider -->
  <div class="sb__divider"></div>

  <!-- Team avatar -->
  <a
    *ngIf="auth.userProfile?.team?.id"
    routerLink="/profile"
    class="sb__item sb__item--avatar"
    [matTooltip]="'BUTTON.MY_PROFILE' | translate"
    matTooltipPosition="right"
    (click)="handleItemClick()"
  >
    <div class="sb__team-avatar">
      <app-s3-image [isRounded]="true" [image]="auth.userProfile?.team?.icon"></app-s3-image>
    </div>
    <span class="sb__active-bar"></span>
  </a>

  <!-- Divider -->
  <div class="sb__divider"></div>

  <!-- Notifications -->
  <button
    type="button"
    class="sb__item"
    [class.sb__item--active]="countUnreadNotifications > 0"
    [matTooltip]="countUnreadNotifications + ' ' + ('NAVBAR.NOTIFICATIONS' | translate)"
    matTooltipPosition="right"
    (click)="openUserNotificationsDialog(); handleItemClick()"
  >
    <mat-icon class="sb__icon" *ngIf="!countUnreadNotifications">notifications</mat-icon>
    <mat-icon class="sb__icon sb__icon--alert" *ngIf="countUnreadNotifications">notifications_active</mat-icon>
    <span class="sb__badge" *ngIf="countUnreadNotifications">{{ countUnreadNotifications }}</span>
  </button>

  <!-- Points -->
  <button
    type="button"
    class="sb__item"
    [matTooltip]="('NAVBAR.SCORE_POINTS' | translate) + ': ' + (auth.rewards?.score || 0)"
    matTooltipPosition="right"
    (click)="openPointsDialog(); handleItemClick()"
  >
    <mat-icon class="sb__icon">bubble_chart</mat-icon>
  </button>
</div>
